"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Row_1 = __importDefault(require("react-bootstrap/Row"));
var config_1 = __importDefault(require("../../config"));
var icon_enum_1 = __importDefault(require("../../shared/enums/icon.enum"));
var orientation_enum_1 = __importDefault(require("../../shared/enums/orientation.enum"));
var position_enum_1 = __importDefault(require("../../shared/enums/position.enum"));
var classMap_1 = __importDefault(require("../../shared/utilities/classMap"));
var action_1 = __importDefault(require("../action"));
var visual_action_1 = __importDefault(require("../visual-action"));
require("./visual-action-container.scss");
function VisualActionContainer(props) {
    var colCount = props.colCount || 3;
    var vertical = props.orientation === orientation_enum_1.default.VERTICAL;
    var staggered = props.staggered || false;
    var breakpoints = config_1.default.defaults.breakpoints;
    var aproxSizes = {
        sm: 270,
        md: 310,
        lg: 350,
        xl: 360
    };
    var sizeValue = ((props === null || props === void 0 ? void 0 : props.items) && props.items.length && props.items[0].size) || undefined;
    var isSizeExplicit = Boolean(sizeValue && sizeValue !== "1:1");
    var getResponsiveClasses = function () {
        return Object.keys(breakpoints)
            .map(function (size) { return "col-".concat(size, "-").concat(Math.floor(12 / counts[size])); })
            .join(" ");
    };
    var counts = {
        sm: colCount - 2,
        md: colCount - 1,
        lg: colCount,
        xl: colCount
    };
    if (sizeValue && isSizeExplicit) {
        Object.keys(breakpoints).map(function (key) {
            counts[key] = Math.floor(breakpoints[key] / aproxSizes[sizeValue]);
            return true;
        });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Row_1.default, { className: (0, classMap_1.default)("mpng-ux-visual-action-container", props.className, vertical ? "flex-column" : "", staggered ? "column-stagger" : "") }, props.items &&
            props.items.map(function (visualActionProps, index) {
                var classes = (0, classMap_1.default)(staggered ? undefined : "mb-4", "col-12", getResponsiveClasses());
                var divRef = visualActionProps.focused ? props.focusRef : null;
                return (react_1.default.createElement("div", { key: index, ref: divRef, className: classes },
                    react_1.default.createElement(visual_action_1.default, __assign({}, visualActionProps))));
            })),
        props.showBackToCurrent && (react_1.default.createElement("div", { className: "back-to-current" },
            react_1.default.createElement(action_1.default, { className: "text-dark back-to-current-label", callback: props.callback, priority: "link", text: props.backToCurrentButtonText || "Back to Current", icon: {
                    textPosition: position_enum_1.default.BOTTOM,
                    icon: props.chevronUp ? icon_enum_1.default.CHEVRON_UP : icon_enum_1.default.CHEVRON_DOWN,
                    className: "bg-primary rounded-circle p-2 text-white mb-2",
                    squared: true
                } })))));
}
exports.default = VisualActionContainer;
